import { Component } from "react";

// custom markup
import TableNew, { CELL_TYPES } from "../../../shared/Table";
import { TableCellAccountRedirect } from "../../../shared/Table/components/Cell";
import RefreshButton from "../../../shared/ui/Refresh.Button";

import { compose } from "redux";

// formatters and other
import _ from "underscore";
import { getDeclineReasonText } from "./CreditApplicationDetails/CreditApplicationDetailsCmps/helper";

// icons
import PropTypes from "prop-types";
import { applicationConnector } from "../../../services/applications/connector";
import { allClaimsOtherThanAml } from "../../../shared/ClaimLists/Claim.Aml.All.List";
import ClaimsWrapper from "../../../shared/ui/Claim.Wrapper";
import CreditApplicationDetails from "./CreditApplicationDetails/Credit.Application.Details.Component";
import TableCellReviewCreditApplicationActions from "../../../services/applications/tables/TableCellReviewCreditApplicationActions";

export function boolRender(value) {
  if (value === true) return "Yes";
  if (value === false) return "No";
  return "not set";
}

export function dictRender(value, dict) {
  // make sure dict is not undefined
  if (!dict) {
    // eslint-disable-next-line no-console
    console.log("dict renderer no dict set");
    dict = {};
  }

  let renderValue = dict[value];

  if (!renderValue) {
    renderValue = "not set";
  }

  return renderValue;
}

class ReviewingCreditApplicationsComponent extends Component {
  constructor(props) {
    super(props);
    let columns = this.getColumns();
    this.state = { columns };
  }

  UNSAFE_componentWillMount() {
    if (this.props.BorrowerId) {
      this.props.getApplicationsForAccount(this.props.BorrowerId);
    } else if (
      this.props.reviewingCreditApplications &&
      !this.props.reviewingCreditApplications.fetching
    ) {
      this.props.getOnHoldCreditApplications();
    }

    this.props.changeApplicationListPage(1);
  }

  addMoreInfo = (row) => {
    this.props.getRowAdditionalData(
      row.BorrowerId,
      row.Identity,
      row.BankAccountId,
      row.Id,
    );
  };

  getDetails = (item, accountInfos) => {
    return (
      <CreditApplicationDetails
        item={item}
        accountInfos={accountInfos}
        approveCreditOffer={this.props.approveCreditOffer}
        rejectCreditOffer={this.props.rejectCreditOffer}
        approveRejectCreditOffers={this.props.approveRejectCreditOffers}
        rejectCreditApplication={this.props.rejectCreditApplication}
      />
    );
  };

  render() {
    let sortedData = _.sortBy(
      this.props.reviewingCreditApplications.data,
      (application) => {
        return new Date(application.UserInfoFinalizedAt).valueOf();
      },
    ).reverse();

    let refreshFunction = this.props.reviewingCreditApplications.data.BorrowerId
      ? this.props.getApplicationsForAccount.bind(this, this.props.BorrowerId)
      : this.props.getOnHoldCreditApplications;

    return (
      <div className="applications-layout body-height content-padding">
        <RefreshButton onRefreshClick={refreshFunction} />
        <h3>Loanstep: Applications On Hold</h3>
        {!this.props.reviewingCreditApplications.fetched ? (
          <div> Loading... </div>
        ) : (
          <TableNew
            {...this.props}
            columns={this.state.columns}
            tableKey={
              "Credit-Applications-Review" +
              !!this.props.reviewingCreditApplications.data.BorrowerId
            }
            selectId={"Id"}
            items={sortedData}
            actionColumnWidth={190}
            showDetailsFun={this.addMoreInfo}
            detailsRenderer={(item) => {
              return this.getDetails(item, this.props.accountInfos);
            }}
          />
        )}
        <br />
      </div>
    );
  }

  getColumns = () => {
    return [
      {
        key: "BorrowerId",
        label: "Get ssn",
        visible: true,
        type: CELL_TYPES.ssn,
        filter: false,
      },
      {
        key: "SubmittedAt",
        label: "Submitted",
        visible: true,
        type: CELL_TYPES.date,
      },
      {
        key: "BorrowerId",
        label: "Borrower Id",
        visible: false,
        type: CELL_TYPES.text,
        renderer: (value) => {
          return <TableCellAccountRedirect value={value} type={"BorrowerId"} />;
        },
      },
      {
        key: "DeclineReason",
        label: "Auto Reject Reason",
        visible: true,
        type: CELL_TYPES.text,
        renderer: (value) => {
          return <span>{getDeclineReasonText(value)}</span>;
        },
      },
      {
        key: "Id",
        label: "Actions",
        visible: true,
        filter: false,
        renderer: (value, item) => {
          return (
            <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
              <TableCellReviewCreditApplicationActions
                approveCreditOffer={this.props.approveCreditOffer}
                rejectCreditApplication={this.props.rejectCreditApplication}
                removeFromOnHold={this.props.removeFromOnHold}
                value={value}
                item={item}
                getAccountInfoForId={this.props.getAccountInfoForId}
                accountInfos={this.props.accountInfos}
              />
            </ClaimsWrapper>
          );
        },
      },
    ];
  };

  static propTypes = {
    getCreditApplications: PropTypes.func,
    getOnHoldCreditApplications: PropTypes.func,
    getRowAdditionalData: PropTypes.func,
    changeApplicationListPage: PropTypes.func,
    approveRejectCreditOffers: PropTypes.func,
    getAccountInfoForId: PropTypes.func,
    removeFromOnHold: PropTypes.func,
    //
    creditApplications: PropTypes.any,
    reviewingCreditApplications: PropTypes.any,
    accountInfos: PropTypes.any,
    accountId: PropTypes.any,
    //
    approveCreditOffer: PropTypes.any,
    rejectCreditApplication: PropTypes.any,
    rejectCreditOffer: PropTypes.any,
  };
}

export default compose(applicationConnector)(
  ReviewingCreditApplicationsComponent,
);
